import { render, staticRenderFns } from "./RoleTableRightsRow.vue?vue&type=template&id=7f6db51f&scoped=true"
import script from "./RoleTableRightsRow.vue?vue&type=script&lang=js"
export * from "./RoleTableRightsRow.vue?vue&type=script&lang=js"
import style0 from "./RoleTableRightsRow.vue?vue&type=style&index=0&id=7f6db51f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6db51f",
  null
  
)

export default component.exports